/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import useWindowSize from "../hooks/useWindowSize"
import { isClient } from "../utils/isClient"

import "../css/vars.css"
import "../css/layout.css"
import "../css/fonts.css"

import { GlobalStyle } from "./styles"

const Layout = ({ children }) => {
  const [aspect, setAspect] = useState(1)
  const { width, height } = useWindowSize()

  useEffect(() => {
    const calcValues = () => setAspect(width / height)
    calcValues()

    if (isClient) {
      window.addEventListener("resize", calcValues)
    }

    return () => {
      if (isClient) {
        window.removeEventListener("resize", calcValues)
      }
    }
  }, [width, height])

  return (
    <>
      <GlobalStyle />
      <main
        className={
          aspect < 0.8
            ? "aspect-ratio-portrait"
            : aspect > 1.2
            ? "aspect-ratio-landscape"
            : ""
        }
      >
        {children}
      </main>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
